import React from 'react';
import styles from './Privacy.module.css';

const PrivacyPolicy = () => (
  <div className={styles.container}>
    <h1>Privacy Policy</h1>
    <p><strong>Last updated:</strong> 7/19/2025</p>

    <p>
      Loggable (“we”, “us”, or “our”) respects your privacy. This Privacy Policy explains how we collect, use, and share your information when you use our mobile and web applications (the “Services”).
    </p>

    <h2>1. Information We Collect</h2>
    <p>
      We collect personal information you provide directly (such as your name and email), usage data, device information, and log data. Payment information is collected and processed securely by our trusted third-party payment processor.
    </p>

    <h2>2. How We Use Your Information</h2>
    <p>
      To provide and improve the Services, manage your account (including payment status and subscriptions), process payments via a trusted third-party processor, communicate with you, and comply with legal obligations.
    </p>

    <h2>3. Data Sharing</h2>
    <p>
      We use trusted third-party services like AWS, Stripe, and OpenAI to help deliver the Services. We do not sell your personal information.
    </p>

    <h2>4. Cookies and Tracking</h2>
    <p>
      We may use cookies and similar technologies to enhance your experience.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We implement industry-standard security measures to protect your data.
    </p>

    <h2>6. Your Rights</h2>
    <p>
      You can access, update, or delete your personal information by contacting support.
    </p>

    <h2>7. Children’s Privacy</h2>
    <p>
      Our Services are not intended for children under 13.
    </p>

    <h2>8. Changes to this Policy</h2>
    <p>
      We may update this Privacy Policy; we will notify you of significant changes.
    </p>

    <h2>9. Contact Us</h2>
    <p>
      For questions about this Privacy Policy, contact <a href="mailto:support@loggable.net">support@loggable.net</a>.
    </p>
  </div>
);

export default PrivacyPolicy;
